export const churchTypeOptions = [
  {
    value: 1,
    label: 'cathedral',
  },
  {
    value: 3,
    label: 'church',
  },
  {
    value: 5,
    label: 'chapel',
  },
]